import styled from 'styled-components';
import RouletteNumbers from './roulette-numbers';
import Seats from './seats';
import breakpoint from '~/utils/style-utils.ts';

const Wrapper = styled.div`
	position: relative;
	height: 36px;
	border-bottom-left-radius: ${({ radius }) => radius || '12px'};
	border-bottom-right-radius: ${({ radius }) => radius || '12px'};
	overflow: hidden;
	padding: 0 6px;
	${breakpoint.lg`
		padding: 0 8px;
  `}
`;

const BlendedBackground = styled.div`
	background: rgba(0, 0, 0, 0.5);
	backdrop-filter: blur(2rem);
	mix-blend-mode: overlay;
	position: absolute;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 0;
`;

const LiveElementsWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
`;

const LiveFeedContainer = ({ liveCasinoGameType, activeSeats, radius, clickHandler, rouletteNumbers }) => {
	const supportedLiveGameTypes = ['blackjack', 'roulette'];

	// ignore double ball values like value: '32|33' while game type is roulette
	if (liveCasinoGameType === 'roulette' && (!rouletteNumbers || rouletteNumbers?.some(n => n.value?.includes('|')))) {
		return null;
	}

	return (
		(supportedLiveGameTypes.includes(liveCasinoGameType) && (
			<Wrapper radius={radius}>
				<BlendedBackground />
				<LiveElementsWrapper>
					{liveCasinoGameType === 'blackjack' && (
						<Seats activeSeats={activeSeats} clickHandler={clickHandler} />
					)}
					{liveCasinoGameType === 'roulette' && rouletteNumbers?.length && (
						<RouletteNumbers rouletteNumbers={rouletteNumbers} />
					)}
				</LiveElementsWrapper>
			</Wrapper>
		)) ||
		null
	);
};

export default LiveFeedContainer;
